import { render, staticRenderFns } from "./gateway-form.vue?vue&type=template&id=1f57125e"
import script from "./gateway-form.vue?vue&type=script&lang=js"
export * from "./gateway-form.vue?vue&type=script&lang=js"
import style0 from "./gateway-form.vue?vue&type=style&index=0&id=1f57125e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports